module.exports = __webpack_public_path__ + "img/P150T_weapon_100.d80355a7.png";